// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 90001-手动触发过期预约记录检查 立即检查并处理所有过期的预约记录，根据商品类型进行相应处理 GET /admin/v1/scheduleManage/triggerExpiredCheck */
export async function triggerExpiredCheck(options?: { [key: string]: any }) {
  return request<API.YmResultVOString>(
    "/admin/v1/scheduleManage/triggerExpiredCheck",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 90003-手动出发场馆当天运营时间 GET /admin/v1/scheduleManage/triggerGymBusinessTime */
export async function triggerGymBusinessTime(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.triggerGymBusinessTimeParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>(
    "/admin/v1/scheduleManage/triggerGymBusinessTime",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 90002-手动触发历史数据迁移 GET /admin/v1/scheduleManage/triggerMigration */
export async function triggerDataMigration(options?: { [key: string]: any }) {
  return request<API.YmResultVOString>(
    "/admin/v1/scheduleManage/triggerMigration",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
